export const FIT_BOUNDS_OPTIONS: maplibregl.FitBoundsOptions = {
  padding: 50 as number,
  maxZoom: 19,
};
